export enum TypeMessageEnum {
    SUCCESS = 1,
    WARN = 2,
    ERROR = 3,
    INFO = 4,
}